import { branch, compose } from 'recompose';

import withPortal from 'shared/utils/withPortal';
import BaseMenu from './BaseMenu';

export default compose(
  branch(
    ({ overlay }) => overlay,
    withPortal,
  ),
)(BaseMenu);
